// @flow strict

export const acceleratedTimingFunction = 'cubic-bezier(0.4, 0, 1, 1)';
export const deceleratedTimingFunction = 'cubic-bezier(0, 0, 0.2, 1)';
export const standardTimingFunction = 'cubic-bezier(0.4, 0, 0.2, 1)';
